export default __webpack_public_path__ + "static/media/instagramDesk.1c128079.svg";